module.exports = __webpack_public_path__ + "img/2.fdf2d992.jpg";